import React from 'react';
import { Link, graphql } from 'gatsby';
import BackgroundImage from 'gatsby-background-image';
import GatsbyImage from 'gatsby-image';
import Section from '@theme/components/Section';
import { getBlogUrl } from '../lib/urls';

export default function FeaturedPost({ children, featured, author, language, divider, link, parent }) {
  const title = (
    <h1>{featured.acf.title}</h1>
  );
  const header = link ? (
    <Link to={getBlogUrl({ parent, page: featured, language })}>
      {title}
    </Link>
  ) : title;
  return (
    <BackgroundImage
      fluid={[
        'linear-gradient( rgba(0,0,0,0.6), rgba(0,0,0,0.6))',
        featured.acf.featured_image.localFile.sharp.fluid
      ]}
    >
      {children}
      <hr className="border-light m-0 opacity-60" />
      <Section className="text-light overlay" dividerBottom={divider}>
        <div className="container pt-6">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-xl-8">
              {header}
              <div className="d-flex align-items-center">
                {author.acf.photo && (
                  <GatsbyImage
                    alt="Image"
                    className="avatar mr-2"
                    fluid={author.acf.photo.localFile.sharp.fluid}
                  />
                )}
                <div>
                  <div>
                    <strong>{author.acf.name}</strong>
                  </div>
                  <div className="text-small text-muted">{featured.acf.publish_date}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Section>
    </BackgroundImage>
  );
}

export const query = graphql`
  fragment FeaturedPost on wordpress__wp_blogposts {
    acf {
      author
      body
      publish_date
      slug
      title
      featured_image {
        localFile {
          sharp: childImageSharp {
            fluid(maxWidth: 1920) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`;